import {Injectable} from '@angular/core';
import {StoreService} from './store.service';
import {HashMap} from '../models/hash-map.model';

@Injectable({
    providedIn: 'root',
})
export class AkitaMimicService {
    private static stores: HashMap<StoreService> = {};

    public static registerStore(storeName: string, store: StoreService): void {
        AkitaMimicService.stores[storeName] = store;
    }

    public resetStores(excludedStoreNames: Array<string> = []): void {
        for (const storeName in AkitaMimicService.stores) {
            if (!excludedStoreNames.includes(storeName)) {
                AkitaMimicService.stores[storeName].reset();
            }
        }
    }
}
